import Visa from '../../../svg/payment/visa.svg';
import MasterCard from '../../../svg/payment/mastercard.svg';
import AmericanExpress from '../../../svg/payment/american-express.svg';

export const Graphics = {
    Visa,
    MasterCard,
    AmericanExpress,
};
